const _u2 = "p";
const _u5 = "i";
const _u1 = "m";
const _u3 = "a";
const _u4 = "t";

const _c3 = "G";
const _c9 = "_";
const _c2 = "2";
const _c6 = "H";
const _c4 = "e";
const _c1 = "l";
const _c8 = "!";
const _c0 = "a";
const _c7 = "r";
const _c5 = "t";

export const Val01 = _u1 + _c0 + _c1 + _u2 + _u3 + _u4 + _c8 + _u5;
export const Val02 = _c1 + _u2 + _u3 + _u1 + _c0 + _c1 + _u5 + _c8 + _u5 + _u2 + _u3 + _u4 ;
export const Val03 = _c1 + _c1 + _c2 + _c3 + _u1 + _c0 + _u1 + _c1 + _c5 + _c8 + _u5 + _u2 + _u3 + _u4 ;
export const Val04 = _u1 + _u2 + _c0 + _u4 + _c5 + _u5;
export const Val05 = _c0 + _c1 + _c1 + _c2 + _c3 + _c4 + _c5 + _c6 + _c4 + _c7 + _c9 + _c8;
export const Val06 = _c1 + _u2 + _u3 + _c0 + _c1 + _c3 + _c8 + _c6 + _c0 + _c1 + _c6 + _c4 + _c7 + _c9 + _c8;
export const Val07 = _c0 + _c1 + _u3 + _c8 + _u5 + _c0 + _c1 + _c6 + _u4 + _c7 + _u3 + _c8;
export const Val08 = _c1 + _u1 + _c0 + _c2 + _u2 + _c4 + _u1 + _c6 + _u2 + _c7 + _c3 + _u2;
export const Val09 = _u2 + _c4 + _u1 + _c6 + _u2 + _c7 + _c3 + _u2 + _c1 + _u1 + _c0 + _c2;
export const Val10 = _c6 + _u2 + _c3 + _u2 + _c1 + _u1 + _u2 + _c2 + _u3;
export const Val11 = _c1 + _u1 + _c0 + _u2 + _u2 + _u4 + _c1 + _c6 + _c2 + _c7 + _c3 + _c4;
export const Val12 = _u2 + _c4 + _u1 + _c6 + _c8 + _u5 + _c0 + _c1 + _c6 + _u4 + _u2 + _c7 + _c3 + _u2;
export const Val13 = _c0 + _c1 + _u3 + _c8 + _u3 + _c7 + _u1 + _c0;
export const Val14 = _c9 + _u5 + _u4 + _c8 + _c7 + _c6 + _u3 + _u1;
export const Val15 = _c0 + _c1 + _u2 + _c4 + _u3 + _c8 + _u2 + _c3 + _u1 + _c0;
export const Val16 = _c6 + _c5 + _u2 + _c4 + _u3 + _u1 + _u1 + _u1 + _u1 + _c1;
export const Val17 = _c5 + _c5 + _u2 + _c5 + _c1 + _c3 + _u5 + _c8 + _u2 + _c3;
export const Val18 = _u2 + _c8 + _c2 + _u2 + _c5 + _c6 + _u4 + _c4 + _u4 + _c5;
export const Val19 = _c8 + _c5 + _u1 + _c8 + _c8 + _c8 + _u3 + _c6 + _c8 + _c7;
export const Val20 = _u4 + _c2 + _u5 + _u3 + _c0 + _c3 + _u2 + _c4 + _c0 + _c9;
export const Val21 = _c6 + _u2 + _c3 + _u2 + _c1 + _u1 + _u2 + _c2 + _u3;
export const Val22 = _c1 + _u1 + _c0 + _u2 + _u2 + _u4 + _c1 + _c6 + _c2 + _c7 + _c3 + _c4;
export const Val23 = _u2 + _c4 + _u1 + _c6 + _c8 + _u5 + _c0 + _c1 + _c6 + _u4 + _u2 + _c7 + _c3 + _u2;
export const Val24 = _c0 + _c1 + _u3 + _c8 + _u3 + _c7 + _u1 + _c0;
export const Val25 = _c9 + _u5 + _u4 + _c8 + _c7 + _c6 + _u3 + _u1;
export const Val26 = _c0 + _c1 + _u2 + _c4 + _u3 + _c8 + _u2 + _c3 + _u1 + _c0;
export const Val27 = _c6 + _c5 + _u2 + _c4 + _u3 + _u1 + _u1 + _u1 + _u1 + _c1;
export const Val28 = _c5 + _c5 + _u2 + _c5 + _c1 + _c3 + _u5 + _c8 + _u2 + _c3;
export const Val29 = _u2 + _c8 + _c2 + _u2 + _c5 + _c6 + _u4 + _c4 + _u4 + _c5;
export const Val30 = _c8 + _c5 + _u1 + _c8 + _c8 + _c8 + _u3 + _c6 + _c8 + _c7;
